module.exports = "<div class=\"pageContent paddingLight classicArea withNav\">\n\t<div class=\"pageNavigation\">\n\t\t<button class=\"showMenu mobile tablet\" ga-track-event=\"['Manage Purchase', 'Click', 'Show/Hide Mobile Menu']\">\n\t\t\t<span class=\"limitContent txtTruncated\">{{ 'managePurchase.viewMenu' | translate }}</span>\n\t\t</button>\n\t\t<navbar></navbar>\n\t</div>\n  <ui-view />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manage-purchase/manage-purchase.html
// module id = 892
// module chunks = 0